/**************************************************
 * Nombre:       Formulario_Artesano
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {PhoneAndroidOutlined, TitleOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Artesano = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={6} ancho={9} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen de 900px por 600px de menos de 300K de peso</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre Anuncio'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'}
                                  dato={'descripcion'} {...props}

                    />

                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Texto Bonton'} dato={'textoBoton'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Link Bonton'} dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Artesano